import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class LanguageService {

  private readonly defaultLanguage = 'en';
  private language = this.defaultLanguage;

  get isWorkingInAnIFrame(): boolean {
    return document.referrer !== '';
  }

  get languageCookieValue(): string {
    if(this.isWorkingInAnIFrame) {
      return this.language;
    }
    return abp.utils.getCookieValue(
      'Abp.Localization.CultureName'
    );
  }

  set languageCookieValue(value: string) {
    if(this.isWorkingInAnIFrame) {
      this.language = value;
    } else {
      abp.utils.setCookieValue(
        'Abp.Localization.CultureName',
        value,
        new Date(new Date().getTime() + 5 * 365 * 86400000), // 5 year
        abp.appPath
      );
    }
  }

}
